import { useEffect } from 'react';
import Lenis from 'lenis';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { MarqueeStrip } from '../components/landing/MarqueeStrip';
import { ValueProp } from '../components/landing/ValueProp';
import { Sessions } from '../components/landing/Sessions';
import { Services } from '../components/landing/Services';
import { Gallery } from '../components/landing/Gallery';
import { Events } from '../components/landing/Events';
import { Contact } from '../components/landing/Contact';
import { Footer } from '../components/landing/Footer';
import { InstagramFab } from '../components/landing/InstagramFab';

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-ink">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <ValueProp />
        <Services />
        <Gallery />
        <Events />
        <Sessions />
        <Contact />
      </main>
      <Footer />
      <InstagramFab />
    </div>
  );
}
